/*
 * simplified pollyfil for ric, assumes a modern es6 context
 *
 * Copyright 2015 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

if (
  globalThis != null &&
  (!globalThis["requestIdleCallback"] || !globalThis["cancelIdleCallback"])
) {
  let shimRequestIdleCallback = function requestIdleCallback(
    cb: (opts: { didTimeout: boolean; timeRemaining: () => number }) => void,
  ): number {
    return setTimeout(function () {
      const start = Date.now();
      cb({
        didTimeout: false,
        timeRemaining: function () {
          return Math.max(0, 50 - (Date.now() - start));
        },
      });
    }, 4) as unknown as number;
  };

  let shimCancelIdleCallback = function cancelIdleCallback(id: number) {
    clearTimeout(id);
  };

  globalThis["requestIdleCallback"] = shimRequestIdleCallback;
  globalThis["cancelIdleCallback"] = shimCancelIdleCallback;
}
